import { render } from "./ru.vue?vue&type=template&id=3055557c&scoped=true&ts=true"
import script from "./ru.vue?vue&type=script&lang=ts"
export * from "./ru.vue?vue&type=script&lang=ts"

import "./ru.vue?vue&type=style&index=0&id=3055557c&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3055557c"]])

export default __exports__